import { FormControl, InputLabel } from '@mui/material';
import { ApiResponse } from '../../models/api-response';
import { useLoadData } from '../../hooks/useLoadData';
import { SelectConfig, SelectResult } from './select-chain.component';
import { LoadingIndicator } from '../loading-indicator.component';
import { AutoCompleteSelect } from '../autocomplete-select.component';

interface SelectChainFilterProps {
  value: SelectResult;
  config: SelectConfig;
  disabled?: boolean;
  onSelect: (selectedItem: SelectResult) => void;
}

export const AutoCompleteSelectItem = ({
  value,
  config: { optionsLabelKey, optionsValueKey, title, getQueryKeyConfig },
  disabled,
  onSelect,
}: SelectChainFilterProps) => {
  const { data, isLoading, isFetching } = useLoadData<ApiResponse<any[]>>(getQueryKeyConfig(value));

  const optionsArray = Array.isArray(data?.data) ? data?.data : [];

  const currentValue = optionsArray?.find((d) => d[optionsValueKey]?.toString() === value[optionsValueKey]?.toString());
  const handleSelect = (value: any) => {
    onSelect({ [optionsValueKey]: value ? value[optionsValueKey] : undefined });
  };

  return (
    <FormControl fullWidth>
      <LoadingIndicator isLoading={isLoading || isFetching} />
      <AutoCompleteSelect
        options={data?.data ?? []}
        selectedValue={currentValue ?? null}
        label={title}
        disabled={disabled}
        optionsLabelKey={optionsLabelKey}
        optionsValueKey={optionsValueKey}
        onChange={handleSelect}
      />
    </FormControl>
  );
};
